/**
 * Translate description: Filter component
 */

import { Fragment, useContext } from 'react';

import { useLanguageContext } from "../../../context/LanguageContext";
import AppContext from '../../../context/AppContext';

import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';

export default () => {
  const { t } = useLanguageContext();
  const { filter, setFilter, setPaginator } = useContext(AppContext);
  return (
    <Fragment>
      <FormControl size="sm">
        <FormLabel>{t('Type')}</FormLabel>
        <Select
          size="sm"
          placeholder={t('Filter by type')}
          slotProps={{
            button: { sx: { whiteSpace: 'nowrap' } },
            listbox: { placement: 'bottom-end' },
          }}
          onChange={(e, v) => {
            if (!e) return;
            let types = {
              "all": null,
              "copy": [3],
              "buy": [1, 2]
            }
            if (types[v]) {
              setFilter({ ...filter, type_id: { value: types[v], operator: "in" } });
            } else {
              let f = { ...filter };
              if (f.type_id) delete f.type_id;
              setFilter(f);
            }
            setPaginator({ currentPage: 1 });
          }}
          defaultValue=""
        >
          <Option value={"all"}>{t('All')}</Option>
          <Option value={"copy"}>{t('Tap')}</Option>
          <Option value={"buy"}>{t('Buy')}</Option>
        </Select>
      </FormControl>
    </Fragment>
  )
};
